// getPublicUrlHostname.js
'use strict';

import { createSelector } from '../resource/createCachedSelector.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import {
  FEATURE_RESOURCE_DECRYPTION,
  PUBLIC_ENCRYPTED_URL_PREFIX,
  PUBLIC_URL_PREFIX,
} from '../RemoteConfigKeys.js';

/**
 * Select public url hostname.
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @return {string} The selected public url hostname.
 */
const getPublicUrlHostname = createSelector(
  state => getRemoteConfigData(state, FEATURE_RESOURCE_DECRYPTION),
  state => getRemoteConfigData(state, PUBLIC_URL_PREFIX),
  state => getRemoteConfigData(state, PUBLIC_ENCRYPTED_URL_PREFIX),
  (isDecryptionRequired, publicUrlPath, publicEncryptedUrlPath) => {
    let publicUrlHostname = publicUrlPath;
    try {
      publicUrlHostname = isDecryptionRequired
        ? new URL(publicEncryptedUrlPath).hostname
        : new URL(publicUrlPath).hostname;
    } catch (error) {
      //
    }
    return publicUrlHostname;
  }
);

export default getPublicUrlHostname;
